import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router";
import { useAppSelector } from "../app/hooks";
import { UserRole } from "../app/userSlice";
import { AdminSessionLoading, useAdminSessionGate } from "./AdminSessionGate";

export default function RequireAdminSession() {
	const { school, district, isAdminSessionSynced } = useAppSelector((state) => state.user);
	const role = useAppSelector((state) => state.user.role);

	const navigate = useNavigate();
	const shouldGate = useAdminSessionGate();

	useEffect(() => {
		// Wait for the sync: until it resolves, school/district are whatever local
		// storage rehydrated, so redirecting now can bounce an admin to the picker
		// mid-sync (whose single-option auto-select then races the sync).
		if (!isAdminSessionSynced) return;

		if (role === UserRole.SchoolAdmin && !school) {
			navigate("/selectSchool");
		}
	}, [role, school, isAdminSessionSynced]);
	useEffect(() => {
		if (!isAdminSessionSynced) return;

		if (role === UserRole.DistrictAdmin && !district) {
			navigate("/selectDistrict");
		}
	}, [role, district, isAdminSessionSynced]);

	if (shouldGate) return <AdminSessionLoading />;

	return <Outlet />;
}
